import isEqual from "lodash/isEqual";
import { useEffect, useRef, useState } from "react";

import { compareArrayData } from "../../../../ui library/helpers/functions";
import DynamicTable from "../modules/DynamicSection/components/DynamicTable";

const Appointments = ({
  columns = [],
  data = [],
  editableFields = [],
  label,
  schema,
  sectionId,
  showAddButton,
  questionKey,
  handleAnswerChange,
  setEnableSave,
  resetValues,
}) => {
  const [tableData, setTableData] = useState(data);
  const prevDataRef = useRef(data);

  useEffect(() => {
    const externalDataChanged = !isEqual(data, prevDataRef.current);
    if (externalDataChanged) {
      setTableData(data);
      prevDataRef.current = data;
    }
  }, [data]);

  useEffect(() => {
    if (resetValues) {
      setTableData([]);
    }
  }, [resetValues]);

  useEffect(() => {
    const changes = compareArrayData(tableData, data);

    if (changes && changes?.length > 0) {
      handleAnswerChange(questionKey, changes);
    } else {
      handleAnswerChange(questionKey, undefined);
    }
  }, [tableData]);

  return (
    <DynamicTable
      addButtonText="Add Appointment"
      showAddButton={showAddButton}
      label={label}
      editableFields={editableFields}
      setTableData={setTableData}
      tableData={tableData}
      sectionId={sectionId}
      schema={schema}
      columns={columns}
      setEnableSave={setEnableSave}
      isAppointments
    />
  );
};

export default Appointments;
